module.exports = __webpack_public_path__ + "img/avatar.7ea4af7d.png";